import axios from 'axios';
import { consoleLogger } from './consoleLogger';
import { checkStubToken } from '@shared/helpers/stubToken';

export const setAxiosCallsInterceptors = () => {
  checkStubToken();
  consoleLogger.logDebug('Setting Axios calls interceptors...');
  axios.interceptors.request.use(
    (config) => {
      consoleLogger.logTrace(
        `Calling url ${config.url} with data:`,
        config.data,
      );
      return config;
    },
    (error) => {
      consoleLogger.logError(
        'Error occurred when setting up a request:',
        error.message,
      );
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      consoleLogger.logTrace(
        `Response from ${response.config.url} with data:`,
        response.data,
        'and status',
        response.status,
      );
      return response;
    },
    (error) => {
      if (error.response) {
        consoleLogger.logTrace(
          'Call for',
          error.response.config.url,
          'failed with response status',
          error.response.status,
          'and reason:',
          error.response.data,
        );
      } else if (error.request) {
        consoleLogger.logError(
          'No response received for a call: ',
          error.request,
        );
      } else {
        consoleLogger.logError('General error occurred: ', error.message);
      }
      return Promise.reject(error);
    },
  );

  consoleLogger.logDebug('Finished setting Axios calls interceptors.');
};
